import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useDispatch} from 'react-redux';
import {clearCashAppRecipient, approveCashAppOrder} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';
import Copy from '../../../components/copy';


export default ({data, recipient, onPayment, cashapp_order}) => {
    const dispatch = useDispatch(),
          navigate = useNavigate();

    const link_to_send = `${recipient.link}/${data.amount.toFixed(2)}`;

    return (
        <>
            <div className="page-title">CashApp</div>
            <div className="page-descriptions">
                Send <b>${data.amount}</b> to the recipient <b>{recipient.tag}</b> and click the «Payment Made» button to process the request
            </div>


            <div className="amount_input">
                <div className="label">Transfer</div>
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{data.amount}</div>
                </div>
            </div>

            <div className="cashapp_receiver">
                <div className="label">To recipient</div>
                <div className="user">
                    <div className="avatar">
                        <img src="../../../images/default_avatar.png" />
                    </div>
                    <div className="details">
                        <div className="cashtag">{recipient.tag}</div>
                        <div className="name">{recipient.name}</div>
                    </div>
                    <Copy value={recipient.tag} fill="#A8D81A" size={24} />
                </div>
            </div>

            <div className="mt10"></div>
            <div className="button green" onClick={e => window.open(link_to_send, '_blank')}>Open CashApp for payment</div>

            <div className="mt20"></div>
            <div className="button blue" onClick={e => {
                dispatch(approveCashAppOrder(cashapp_order.paymentId));
                onPayment();
            }}>Payment made</div>

            <div className="button" onClick={e => {
                dispatch(clearCashAppRecipient());
                navigate('/');
            }}>Cancel payment</div>
        </>
    )
}